import { PATIENT_CONSULTATION_STATUS } from "~/common/constants";

export const intakeAvailable = (consultationStatus?: string) =>
  consultationStatus !== PATIENT_CONSULTATION_STATUS.screening_started &&
  consultationStatus !== PATIENT_CONSULTATION_STATUS.screening_submitted &&
  consultationStatus !== PATIENT_CONSULTATION_STATUS.screening_not_started &&
  consultationStatus !== PATIENT_CONSULTATION_STATUS.closed_after_screening;
